/**
 * Mapping between legacy email template tags (%tagName%) used in system templates
 * and the new format (%{category.field}%) used by the email templates tags API.
 *
 * Source: app/Api/CustomTag/Mapping/EmailCustomTagMapping.php
 *         app/BoundedContext/EmailEngine/Sending/Domain/Service/TemplateService.php
 */
const LEGACY_TAG_TO_NEW: Record<string, string> = {
    // Account
    '%corpName%': '%{account.name}%',
    '%corpTel%': '%{account.phone_number}%',
    '%corpFax%': '%{account.fax_number}%',
    '%corpEmail%': '%{account.email}%',
    '%corpWeb%': '%{account.website}%',
    '%corpAddress%': '%{account.address}%',
    '%corpLogo%': '%{account.logo}%',
    '%corpSiret%': '%{account.siret}%',
    '%corpSiren%': '%{account.siren}%',
    '%corpApenaf%': '%{account.ape_naf_code}%',
    '%corpRcs%': '%{account.rcs_immatriculation}%',
    '%corpCapital%': '%{account.capital}%',
    '%corpType%': '%{account.type}%',
    '%corpVat%': '%{account.vat}%',
    // Staff
    '%staffName%': '%{staff.last_name}%',
    '%staffForename%': '%{staff.first_name}%',
    '%staffPosition%': '%{staff.position}%',
    '%staffEmail%': '%{staff.email}%',
    '%staffTel%': '%{staff.phone_number}%',
    '%staffMobile%': '%{staff.mobile_number}%',
    '%staffFax%': '%{staff.fax_number}%',
    // Contact
    '%thirdCorpName%': '%{contact.name}%',
    '%thirdCiv%': '%{contact.civility}%',
    '%thirdName%': '%{contact.last_name}%',
    '%thirdForename%': '%{contact.first_name}%',
    '%thirdWeb%': '%{contact.website}%',
    '%thirdEmail%': '%{contact.email}%',
    // Document
    '%ident%': '%{document.number}%',
    '%docAmount%': '%{document.total_incl_tax}%',
    '%docAmountHT%': '%{document.total_excl_tax}%',
    '%docDue%': '%{document.total_remaining_due_excl_tax}%',
    '%docDate%': '%{document.date}%',
    '%docExpireDate%': '%{document.expire_date}%',
    '%docObject%': '%{document.subject}%',
    '%docTrackingNum%': '%{document.tracking_number}%',
    '%docTracking%': '%{document.tracking_url}%',
    '%paymentAmount%': '%{document.total_remaining_due_incl_tax}%',
    '%paymentDate%': '%{document.payment_date}%',
    '%linkPayment%': '%{document.url_text}%',
    '%documentUrl%': '%{document.url}%',
    '%payMediums%': '%{document.pay_mediums}%',
    // Login
    '%urlSignin%': '%{login_signin.website}%',
};

export { LEGACY_TAG_TO_NEW };
